import { Fragment } from 'react';

import { rage } from '~/rage';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground } from './Background.styled';

const Background: React.FC = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.DefaultNight} />
			)}
			<StyledBackground />
		</Fragment>
	);
};

export { Background };
